exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".entry {\n  background-color: #FFF;\n  border-bottom: 1px solid RGB(243, 239, 239);\n  font-family: Roboto;\n  font-size: 14px;\n  font-weight: 400;\n  height: 15px;\n  overflow-x: scroll;\n  overflow-y: hidden;\n  padding: 20px 20px 14px 20px;\n  position: absolute;\n  width: calc(100% - 40px);\n  white-space: nowrap; }\n\n:host ::-webkit-scrollbar {\n  display: none; }\n\n#header {\n  background-color: #F4F4F4;\n  color: RGB(156, 156, 156);\n  font-family: Roboto;\n  font-size: 11px;\n  font-weight: 300;\n  height: 13px;\n  padding: 6px 13px 5px 13px;\n  position: absolute;\n  width: calc(100% - 26px); }\n\n#shadow {\n  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.5);\n  height: 10px;\n  left: -5px;\n  position: absolute;\n  top: -10px;\n  width: calc(100% + 10px); }\n\n#shadow-wrapper {\n  height: 5px;\n  opacity: 0;\n  overflow: hidden;\n  position: absolute;\n  top: 0;\n  width: 100%; }\n\n/* Desktop */\n#shadow-wrapper.desktop {\n  opacity: 1; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/electraLib/component/searchResults/searchResults.component.scss
// module id = 413
// module chunks = 1